import cx from 'classnames';
import * as Draft from 'draft-js';

import * as draftUtils from 'utils/draft';

import Text from '../Typography/Text';
import { customStyleFn } from './customStyles';
import { Toolbar } from './Toolbar';
import { LinkPortal } from './Toolbar/Items/Link/Link';
import { useWysiwygContext, withWysiwyg } from './Wysiwyg.contex';
import s from './Wysiwyg.module.css';

export const Wysiwyg = withWysiwyg(() => {
  const { props, editor } = useWysiwygContext();

  const textLength = editor.editorState.getCurrentContent().getPlainText().length;
  const isPrimary = props.type === 'primary';
  const isSecondary = props.type === 'secondary';
  const isTertiary = props.type === 'tertiary';
  const isPrimaryAndFocused = isPrimary && editor.isFocused;
  const isShowLimit = props.limit && !props.hideLimit && editor.isFocused;
  const isShowFooter = !!props.footer && (!isPrimary || isPrimaryAndFocused);

  const sectionsClassNames = {
    container: cx(
      s.container,
      {
        [s.primaryContainer]: isPrimary,
        [s.primaryAndFocusedContainer]: isPrimaryAndFocused,
        [s.secondaryContainer]: isSecondary,
        [s.tertiaryContainer]: isTertiary,
        [s.disabledContainer]: props.isDisabled,
      },
      props.containerClassName,
      'custom-text',
    ),
    body: cx(
      s.body,
      {
        [s.primaryBody]: isPrimary,
        [s.primaryAndFocusedBody]: isPrimaryAndFocused,
      },
      props.bodyClassName,
    ),
  };

  const placeholder = (() => {
    if (props.isReadOnly) return '';

    if (editor.isFocused) return props.focusedPlaceholder;

    return props.placeholder;
  })();

  return (
    <div className={s.wrapper}>
      <div className={sectionsClassNames.container} onMouseDown={() => editor.focus()} ref={editor.refs.containerRef}>
        <Toolbar />
        <div className={sectionsClassNames.body}>
          <Draft.Editor
            tabIndex={props.isReadOnly ? -1 : 0}
            ref={editor.refs.editorRef}
            editorState={editor.editorState}
            onChange={draftUtils.secureOnChange(editor.handleChange)}
            customStyleFn={customStyleFn}
            customStyleMap={customStyleMap}
            keyBindingFn={editor.keyBindingFn}
            readOnly={props.isReadOnly}
            spellCheck={editor.isFocused}
            handleDrop={() => 'handled'}
            placeholder={placeholder}
            handleKeyCommand={editor.handleKeyCommand}
            handlePastedText={editor.handlePastedText}
            blockStyleFn={editor.blockStyleFn}
            onFocus={editor.focus}
          />

          {isShowFooter && <div className={s.footer}>{props.footer}</div>}

          {isShowLimit && (
            <Text
              className={cx(s.textLength, {
                [s.red]: textLength >= props.limit,
              })}
              accent
              size="small"
            >
              {textLength}/{props.limit}
            </Text>
          )}
        </div>
      </div>

      <LinkPortal />
    </div>
  );
});

const customStyleMap = {
  CUSTOM_SELECTED_yes: {
    background: '#c1d9ff',
    padding: '2px 0',
  },
};
